// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InboundMeasuringTicket.yaml
// Generated: 2026-09-17T09:15:49.016Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInboundMeasuringTicket, UpdateInboundMeasuringTicket, InboundMeasuringTicket } from '@/types/procurement/InboundMeasuringTicket';

/**
 * InboundMeasuringTicket Service
 * CRUD operations for InboundMeasuringTicket via the ABP API.
 */
export const inboundMeasuringTicketService = new EntityService<InboundMeasuringTicket, CreateInboundMeasuringTicket, UpdateInboundMeasuringTicket>(
  '/api/procurement/inboundmeasuringticket',
  'InboundMeasuringTicket',
);
